import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IQuestionarios } from '../../models/questionarios';
import { QuestionariosService } from '../../services/questionarios.service';

@Component({
  selector: 'app-status-questionario',
  templateUrl: './status-questionario.component.html',
  styleUrls: ['./status-questionario.component.scss']
})
export class StatusQuestionarioComponent {
  @Output() recarregarListagem = new EventEmitter();
  @Input() questionarios: IQuestionarios[] = [];

  constructor(private readonly questionarioService: QuestionariosService,
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly toastService: ToastService) { }

}
